module.exports = __webpack_public_path__ + "img/ic_dropdown_inactive.23fbd31e.svg";